var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3TemperatureMgt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 58a4.999 4.999 0 11-7-4.58V35h4v18.42A5 5 0 0143 58zm4-9.38a13 13 0 11-18 0V7h18v41.62zM47 58a9 9 0 00-3.27-6.94l-.73-.6V29h-7v-4h7v-4h-7v-4h7v-6H33v39.46l-.73.6A9 9 0 1047 58zm14-46V7h-4v5h-5v4h5v5h4v-5h5v-4h-5zM8 16h14v-4H8v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Temperature_mgt.12659a0b.svg";
export { SvgB3TemperatureMgt as ReactComponent };